import { render, staticRenderFns } from "./BogiEditor.vue?vue&type=template&id=4b1448a0&scoped=true&"
import script from "./BogiEditor.vue?vue&type=script&lang=js&"
export * from "./BogiEditor.vue?vue&type=script&lang=js&"
import style0 from "./BogiEditor.vue?vue&type=style&index=0&id=4b1448a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1448a0",
  null
  
)

export default component.exports